import { combineReducers } from 'redux';
import { SET_PRIVATEUSER, SET_DATACOMMUNICATIONQRCODE, SET_PRIVATEUSERRESULT } from '../actions/weChat_action';

function dataCommunicationQrcode(state = "", action) {
  switch (action.type) {
      case SET_DATACOMMUNICATIONQRCODE:
        return action.dataCommunicationQrcode;
      default:
        return state;
  }
}

function privateUser(state = null, action) {
    switch (action.type) {
        case SET_PRIVATEUSER:
          return action.privateUser;
        default:
          return state
    }
}

function privateUserResult(state = null, action) {
    switch (action.type) {
        case SET_PRIVATEUSERRESULT:
          return action.privateUserResult;
        default:
          return state;
    }
}

const weChatReducer = combineReducers({
  dataCommunicationQrcode,
  privateUser,
  privateUserResult
});

export default weChatReducer
